import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../../shared/guards/auth.service';
import { Routes } from '../../shared/routePath/route';
import { NavSidebarService } from '../../shared/services/nav-sidebar.service';
import { filter } from 'rxjs/operators';

export interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
    role: string[];
    display: boolean;
    children?: RouteInfo[];
    activePath: string
}
export const ROUTES: RouteInfo[] = [
    { path: Routes.PROMOTIONS.URL, activePath:Routes.PROMOTIONS.PATH, title: Routes.PROMOTIONS.TITLE, icon: '', class: 'karl-ic-promotion karl-ic', display: true, role: Routes.PROMOTIONS.ROLE,  },
    { path: Routes.PRICE_CATALOGUE.URL, activePath:Routes.PRICE_CATALOGUE.PATH, title: Routes.PRICE_CATALOGUE.TITLE, icon: '', class: 'karl-ic-price-catalog karl-ic', display: true, role: Routes.PRICE_CATALOGUE.ROLE,  },
    // { path: Routes.PRODUCT_SELECTION.URL, activePath:Routes.PRODUCT_SELECTION.PATH, title: Routes.PRODUCT_SELECTION.TITLE, icon: '', class: 'ik-product-selection ik-icon', display: true, role: Routes.PRODUCT_SELECTION.ROLE },
    { path: Routes.CONFIGURATION.URL, activePath:Routes.CONFIGURATION.PATH, title: Routes.CONFIGURATION.TITLE, icon: '', class:'karl-ic-configuration  karl-ic', display: true, role: Routes.CONFIGURATION.ROLE, children:[
        { path: Routes.SYNC_PRODUCT.URL, activePath:Routes.SYNC_PRODUCT.PATH, title: Routes.SYNC_PRODUCT.TITLE, icon: '', class: 'karl-ic-sync karl-ic', display: true, role: Routes.SYNC_PRODUCT.ROLE },
        { path: Routes.ROUNDING_RULES.URL, activePath:Routes.ROUNDING_RULES.PATH, title: Routes.ROUNDING_RULES.TITLE, icon: '', class: 'karl-ic-rounding-rules karl-ic', display: true, role: Routes.ROUNDING_RULES.ROLE },
        { path: Routes.TRADEBYTE.URL, activePath:Routes.TRADEBYTE.PATH, title: Routes.TRADEBYTE.TITLE, icon: '', class: 'karl-ic-tradebyte karl-ic', display: true, role: Routes.TRADEBYTE.ROLE },        
        { path: Routes.PRICE_LIST_MASTER.URL, activePath:Routes.PRICE_LIST_MASTER.PATH, title: Routes.PRICE_LIST_MASTER.TITLE, icon: '', class: 'karl-ic-hanger-plan karl-ic', display: true, role: Routes.PRICE_LIST_MASTER.ROLE },
    ] },
];

@Component({
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    standalone: false
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    public expandedMenus: { [key: string]: boolean } = {};
    private toggleButton;
    private sidebarVisible: boolean;
    public activeRoute: string = '';
    public isMinimized: boolean;
    public newFeatureFlag:string[] = []; //[Routes.CONFIGURATION.TITLE, Routes.SYNC_PRODUCT.TITLE, Routes.ROUNDING_RULES.TITLE, Routes.TRADEBYTE.TITLE ]; // Example feature flag

    constructor(private authService: AuthService, private element: ElementRef, private router: Router,
        private readonly _navSidebarService: NavSidebarService,
        private readonly _activatedRoute: ActivatedRoute
    ) {
        this.sidebarVisible = false;
    }

    ngOnInit() {
        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        const roleList: string[] = this.authService.getRoleList();



        this.menuItems = ROUTES.filter(menuItem => {
            if (menuItem.role && menuItem.role.length > 0) {
                const roleExistList = menuItem.role.filter(role => roleList.indexOf(role) > -1);
                return roleExistList.length > 0;
            }
            return menuItem;
        });

        this._navSidebarService.isMinimized$.subscribe((value: boolean) => {
            this.isMinimized = value;
        });

        this.setActiveRoute(this.router.url);

        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.setActiveRoute(event.urlAfterRedirects);
                // this.activeRoute = event.urlAfterRedirects;

                // // If route matches /product-selection/:id, mark promotions as active
                // if (this.activeRoute.match(/^\/product-selection\/[A-Za-z0-9-]+$/)) {
                //     this.activeRoute = Routes.PROMOTIONS.URL;
                // }
            });

        this.getDrawerStatus();
    }

    toggleMenu(menu: any, event: Event) {
        if (menu.children && menu.children.length) {
            event.preventDefault();
            this.expandedMenus[menu.title] = !this.expandedMenus[menu.title];
        }
    }

    private setActiveRoute(url: string): void {
        this.activeRoute = url;
    
        if (this.activeRoute.match(/^\/product-selection\/[A-Za-z0-9-]+$/)) {
            this.activeRoute = Routes.PROMOTIONS.URL;
        }
    
        // Expand parent if child route active
        this.menuItems?.forEach(menu => {
            if (menu.children) {
                const childMatch = menu.children.some(c =>
                    this.activeRoute.startsWith('/' + c.activePath)
                );
                if (childMatch) {
                    this.expandedMenus[menu.title] = true;
                }
            }
        });
    }

    sidebarToggle() {
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    }

    toggleSidebar() {
        this.router.navigate(['/']);
        // this._navSidebarService.sidebarWebToggle();
        // this.router.navigate([], { relativeTo: this._activatedRoute });

    }


    getDrawerStatus() {
        let status = sessionStorage.getItem('hideDrawer');
        if (status && status == 'true') {
            sessionStorage.setItem('hideDrawer', "true");
            document.getElementsByTagName('body')[0].classList.add("sidebar-mini");
            this.isMinimized = true;
        } else {
            this.isMinimized = false;
            sessionStorage.setItem('hideDrawer', "false");
            document.getElementsByTagName('body')[0].classList.remove("sidebar-mini");
        }
    }

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const html = document.getElementsByTagName('html')[0];
        const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
        setTimeout(() => toggleButton.classList.add('toggled'), 500);

        html.classList.add('nav-open');
        if (window.innerWidth < 991) {
            mainPanel.style.position = 'fixed';
        }
        this.sidebarVisible = true;
    };

    sidebarClose() {
        const html = document.getElementsByTagName('html')[0];
        const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
        if (window.innerWidth < 991) {
            setTimeout(function () {
                mainPanel.style.position = '';
            }, 500);
            // Use service to remove overlay
            this._navSidebarService.sidebarMobileClose();
        }
        if (this.toggleButton) {
            this.toggleButton.classList.remove('toggled');
        }
        this.sidebarVisible = false;
        html.classList.remove('nav-open');
    };

    closeSidebarOnMobile() {
        if (window.innerWidth < 991 && this.sidebarVisible) {
            this.sidebarClose();
        }
    }
}

